import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TipoProfissionalDescPipe } from '@app/features-modules/bolsa-de-profissionais/pipes/tipo-profissional-desc.pipe';
import { TagModule } from 'primeng/tag';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-card-profissional',
  imports: [CommonModule, TagModule, TipoProfissionalDescPipe, AvatarModule],
  templateUrl: './card-profissional.component.html',
  styleUrl: './card-profissional.component.scss'
})
export class CardProfissionalComponent {

   @Input() profissional: any;
   imageError = false;

   get foto() {
     return this.profissional?.foto || this.profissional?.photo || this.profissional?.avatar || null;
   }

   getInitials(name?: string | null): string {
     return getInitials(name);
   }
    
      get nome() {
        return this.profissional?.nome || '';
      }
    
      get designacao () {
       return this.profissional?.designacao || 0
      }
    
      get estadoID() {
        return this.profissional?.estadoID;
      }
    
      get tipoProfissional() {
        return this.profissional?.tipoProfissional;
      }
    
      get estado() {
        return this.profissional?.estado;
      }
    
      getSeverity(estado: string): any {
        switch (estado) {
          case 'Individual':
            return 'info';
          case 'Recém Formado':
            return 'warn';
          case 'Bolseiro':
            return 'success';
          default:
            return 'info';
        }
      }
}
